export type SnListItemHideExpression = () => boolean;
